import { render, staticRenderFns } from "./PageCroutonPlaceholder.vue?vue&type=template&id=57ee945c&"
import script from "./PageCroutonPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PageCroutonPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports